import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { Button } from '../../../../components/button/Button';
import { ConfirmationDialog } from '../../../../components/dialog-types/ConfirmationDialog';
import { ChiTooltip } from '../../../../components/utility/ChiTooltip';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { TransportationUtils } from '../../../../transportation/helpers';
import { PickupStatus, PickupStatusMetadata } from '../../../../transportation/models/enums/pickup-status';
import { PickupRead } from '../../../../transportation/models/pickups/pickup-read';

interface IProps {
    pickup: PickupRead;
    updatePickupState: any;
}

interface IStepItem {
    label: string;
    value: number;
}

export const EditPickupStatus = (props: IProps) => {

    const [showConfimDialog, setShowConfirmDialog]  = React.useState(false);
    
    const updatePickupState = () => {
        setShowConfirmDialog(false);
        props.updatePickupState();
    };

    const getButtonLabel = () => {

        // Trucks from MAIN go from Open to InProduction
        if (props.pickup.status === PickupStatus.Open) {
            return "Mark as Delivered >";
        }
        else {
            return "";
        }
    };

    const getDialogText = () => {

        if (props.pickup.status === PickupStatus.Open) {
            return { 
                title: "Mark as Delivered?",
                body: "Are you sure you want to mark this pickup as delivered?  This will begin the invoicing process."
            };
        }
        else {
            return { 
                title: "",
                body: ""
            };
        }
    };

    // A pickup is taken with its orders, so each has to be produced, or not need producing
    const unproducedOrders = TransportationUtils.findUnproducedOrders(props.pickup.orders);

    const shouldButtonDisable = () => {
        return unproducedOrders.length > 0;
    };

    const getHelpText = () => {
        return `Before delivering the pickup, every order must be produced.  Not produced yet: ${ unproducedOrders.map(x => x.id).join(', ') }.`;
    };

    return <div className="row delivery-status-control divider-row">
            <div className="col-md-12">
                <h2>STATUS</h2>
                <p>Currently: <span>{ PickupStatusMetadata[props.pickup.status].display }</span></p>
                {
                    (props.pickup.status !== PickupStatus.Delivered)
                        ? <div className="advance-status-button">
                                <HasPermission requiredPermissions={[
                                    Permissions.ShippingPickupsEdit
                                ]}> 
                                    <Button
                                        classes="next-status-button attention"
                                        testID="pickup-status-btn"
                                        disable={ shouldButtonDisable() }
                                        onBtnClick={(e: any) => {
                                            e.preventDefault(); 
                                            setShowConfirmDialog(true);
                                        }}
                                        text={getButtonLabel()}
                                    />
                                    {
                                        shouldButtonDisable()
                                        ? <ChiTooltip
                                            title="Why is this disabled?"
                                            body={ <p>{ getHelpText() }</p> }
                                        />
                                        : null
                                    }
                                </HasPermission>
                        </div>
                        : null
                }
                {
                    showConfimDialog  
                    ? <ConfirmationDialog
                        {...getDialogText()}
                        successCallback={ () => updatePickupState() }
                        cancelCallback={ () => setShowConfirmDialog(false) } />  
                    : null
                } 
        </div>
    </div>;
        
};
